export default function generateSharePageHtml(files) {
	const fileListItems = files.map((f) => `<li><a href="${f.url}">${f.name}</a></li>`).join("\n");

	const filesJson = JSON.stringify(files.map((f) => ({ name: f.name, url: f.url })));

	return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Download files</title>
  <style>
    body { font-family: sans-serif; max-width: 800px; margin: 2em auto; padding: 0 1em; }
    ul { list-style: none; padding: 0; }
    li { padding: 0.4em 0; }
    a { text-decoration: none; color: #2185d0; }
    a:hover { text-decoration: underline; }
    button { margin-top: 1em; padding: 0.5em 1.2em; background: #2185d0; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 1em; }
    button:hover { background: #1678c2; }
    #status { margin-top: 0.5em; font-size: 0.9em; color: #666; }
  </style>
</head>
<body>
  <button onclick="downloadAll()">Download all</button>
    <div id="status"></div>
  <ul>
${fileListItems}
  </ul>
  <script>
    var files = ${filesJson};
    async function downloadAll() {
      var status = document.getElementById("status");
      for (var i = 0; i < files.length; i++) {
        var file = files[i];
        status.textContent = "Downloading " + (i + 1) + " / " + files.length + ": " + file.name;
        try {
          var res = await fetch(file.url);
          var blob = await res.blob();
          var a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          a.download = file.name;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(a.href);
        } catch (e) {
          status.textContent = "Failed to download " + file.name;
          return;
        }
      }
      status.textContent = "Done!";
    }
  </script>
</body>
</html>`;
}
